import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const CustomSelect = ({ options = [], value, onChange, placeholder, isDisabled = false }) => {
    const [open, setOpen] = useState(false);
    const [dropdownStyle, setDropdownStyle] = useState({});
    const ref = useRef();

    const safeOptions = Array.isArray(options) ? options : [];
    const selected = safeOptions.find((opt) => opt.value === value);

    useEffect(() => {
        if (open && ref.current) {
            const rect = ref.current.getBoundingClientRect();
            setDropdownStyle({
                position: "fixed",
                top: rect.bottom + 4,
                left: rect.left,
                width: rect.width,
                zIndex: 9999,
            });
        }
    }, [open]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                const dropdownElement = document.querySelector('[data-custom-select-dropdown="true"]');
                if (dropdownElement && !dropdownElement.contains(e.target)) {
                    setOpen(false);
                } else if (!dropdownElement) {
                    setOpen(false);
                }
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    return (
        <>
            <div ref={ref} className="relative w-full">
                <div
                    onClick={(e) => {
                        if (isDisabled) return;
                        e.stopPropagation();
                        setOpen((prev) => !prev);
                    }}
                    className={`flex items-center justify-between w-full px-2 py-1 border rounded-md h-[34px]
                        ${isDisabled
                            ? "border-gray-200 bg-gray-50 cursor-not-allowed text-gray-400"
                            : "border-gray-300 bg-white cursor-pointer"
                        }`}
                >
                    <span className={`truncate text-sm ${selected ? (isDisabled ? "text-gray-400" : "text-gray-800") : "text-gray-400"}`}>
                        {selected ? selected.label : (safeOptions.length === 0 && value ? value : placeholder)}
                    </span>
                    {open ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
                </div>
            </div>

            {open && !isDisabled &&
                createPortal(
                    <div
                        data-custom-select-dropdown="true"
                        style={dropdownStyle}
                        className="bg-white border border-gray-300 rounded-md shadow-md max-h-40 overflow-auto text-sm"
                    >
                        {safeOptions.length === 0 ? (
                            <div className="px-3 py-2 text-gray-400 text-sm">No options available</div>
                        ) : (
                            safeOptions.map((opt) => (
                                <div
                                    key={opt.value}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onChange(opt.value);
                                        setOpen(false);
                                    }}
                                    className={`px-2 py-1.5 cursor-pointer truncate hover:bg-blue-50 ${value === opt.value ? "bg-blue-100 text-blue-700" : "text-gray-800"}`}
                                >
                                    {opt.label}
                                </div>
                            ))
                        )}
                    </div>,
                    document.body
                )}
        </>
    );
};

export default CustomSelect;